export default {
    state: {
      defaultData: {},
    },
  
    getters: {
      getTestData(state) {
        return state.defaultData;
      },
    },
  
    mutations: {
      setTestData(state, data) {
        const isNull = data === null;
  
        state.defaultData = {
          id: !isNull ? data.id : "",
          test_laboratory_type_id : !isNull ? Number(data.test_laboratory_type_id)  : "",
          sample : !isNull ? Number(data.sample_test_id)  : "",
          product : !isNull ? data.product  : "",
          method  : !isNull ? Number(data.method_test_id) : "",
          batch  : !isNull ? data.batch  : "",
          validity : !isNull ? data.validity  : "",
          quantity : !isNull ? Number(data.quantity ) : "",
          unity_email  : !isNull ? data.unity_email   : "",
          health_center_id  : !isNull ? Number(data.health_center_id)   : "",
          event_id  : !isNull ? Number(data.event_id)   : "",
        };
      },
    },
  
    actions: {
        changeTestData(context, infos) {
        context.commit("setTestData", infos);
      },
    },
  };
//falta colocar os dados certos